import styled from 'styled-components'

import { Image } from 'components/v2/Image'
import { Text } from 'components/v2/Text'

export const StyledImage = styled(Image)`
  position: absolute;
  right: 0;

  width: 655px;
  height: 526px;

  align-self: center;
  margin-right: 64px;
  max-width: fit-content;
  @media (max-width: 832px) {
    filter: brightness(0.8);
  }

  @media (max-width: 1024px) {
    top: 200px;
    margin-right: auto;
  }
`

export const StyledLink = styled(Text)`
  text-decoration: underline;
  color: ${({ theme: { colors } }) => colors.primary} !important;
  cursor: pointer;
  font-weight: 400;
  font-size: 14px;
`

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  width: 100%;
  ${({ theme: { colors, shadows } }) => `
    max-width: 558px;
    max-height: 500px;
    height: 100%;
    background: ${colors.white};
    box-shadow: ${shadows.boxShadow};
    border-radius: 6px;
    padding: 20px 30px 30px;
  `}
`

export const ToastWrapper = styled.div`
  background: white;
  max-width: 400px;
  padding: 16px;
  border-radius: 4px;
  position: absolute;
  bottom: 165px;
  right: 50px;
  z-index: 2;
`

export const IconContainer = styled.div`
  cursor: pointer;
  height: 16px;
  width: 16px;
`
